import { linearGradient } from "polished";
import { css } from "styled-components";
const backgrounds = {
  default: {
    dark: css(["", " background-attachment:fixed;"], linearGradient({
      colorStops: ["#371F95", "#28268A"],
      toDirection: "to bottom right",
      fallback: "#28268A"
    })),
    light: css(["background-color:#f4fafd;"])
  },
  primary: {
    dark: css(["", " background-attachment:fixed;"], linearGradient({
      colorStops: ["#4F30B3", "#3634A3"],
      toDirection: "to bottom right",
      fallback: "#3634A3"
    })),
    light: css(["background-color:#fff;"]),
    semantic: css(["background-color:#fff;"])
  },
  secondary: {
    dark: css(["", " background-attachment:fixed;"], linearGradient({
      colorStops: ["#4F30B3", "#3634A3"],
      toDirection: "to bottom right",
      fallback: "#3634A3"
    })),
    light: css(["background-color:#e1eef5;"]),
    semantic: css(["background-color:#f4fafd;"])
  },
  clip: {
    dark: linearGradient({
      colorStops: ["#694AD6", "#4744BB"],
      toDirection: "to bottom right",
      fallback: "#4744BB"
    }),
    light: css(["background-color:rgba(255,255,255,1);"])
  },
  selection: {
    dark: css(["", " mix-blend-mode:darken;"], linearGradient({
      colorStops: ["rgba(21, 0, 255, 0.1)", "rgba(15, 0, 105, 0.1)"],
      toDirection: "to bottom",
      fallback: "rgba(15, 0, 105, 0.2)"
    })),
    light: css(["background-color:#e1eef5;opacity:0.7;"]),
    semantic: css(["background-color:#c9deea;opacity:0.5;"])
  }
};
export default backgrounds;
//# sourceMappingURL=backgrounds.js.map